import { Route, Routes } from 'react-router-dom';
import { Modals } from './components/Modals/Modals';
import { UpdateModal } from './components/UpdateModal/UpdateModal';


export const ModalsPage = () => {

    // ### State
    
    // ### Effects

    // ### Functions

    // ### Views

    return(
        <Routes>
            <Route index element={<Modals />} />
            <Route path="/update" element={<UpdateModal />} />
        </Routes>
    )
}